import sleigh from '@pages/diver/assets/new-year/sleigh.svg';
import SleighWaiting from '@pages/diver/assets/new-year/sleigh-waiting';

export const GAME_CONFIG_NEW_YEAR = {
    skinId: 'new-year',
    submarineWidth: 243,
    submarineHeight: 76,
    submarineOffsetX: 70,
    submarineOffsetY: 28,
    submarine: sleigh,
    waitingSubmarine: SleighWaiting,
    historySubmarine: SleighWaiting,
};
